// MEO Phase 1 Sprint 2-F (2026-05-13): landmark_neighborhoods CRUD client.
// api 側 implementation: omikuji-api Sprint 2 (Spec: design/meo-landmark-ads-spec.md §13)
//
// auth: ADMIN (全 landmark) / BUSINESS (自分が sponsor の landmark のみ)。

import ApiService from './ApiService';

export default class LandmarkNeighborhoodsApi extends ApiService {
    // GET /system/landmarks/:landmarkId/neighborhoods
    list(landmarkId: string | number) {
        return this.get(`landmarks/${landmarkId}/neighborhoods`);
    }

    // POST /system/landmarks/:landmarkId/neighborhoods
    create(payload: { landmarkId: string | number, data: any }) {
        const { landmarkId, data } = payload;
        return this.post(`landmarks/${landmarkId}/neighborhoods`, data);
    }

    // PUT /system/landmarks/:landmarkId/neighborhoods/:id
    update(payload: { landmarkId: string | number, id: string | number, data: any }) {
        const { landmarkId, id, data } = payload;
        return this.put(`landmarks/${landmarkId}/neighborhoods/${id}`, data);
    }

    // DELETE /system/landmarks/:landmarkId/neighborhoods/:id
    remove(payload: { landmarkId: string | number, id: string | number }) {
        const { landmarkId, id } = payload;
        return this.delete(`landmarks/${landmarkId}/neighborhoods/${id}`);
    }
}
